<template>
    <div class="alert alert-primary" role="alert">
        <div class="row">
            <div class="col-12 text-center py-3">
                <strong>Поточні показники</strong>
            </div>
            <div class="col-12 py-2">
                <i class="fas fa-fw fa-cloud"></i>
                <span class="pl-3">PM2.5: <strong>{{ last.PM25 }} мкг/м³</strong></span>
            </div>
            <div class="col-12 py-2">
                <i class="fas fa-fw fa-cloud"></i>
                <span class="pl-3">PM10: <strong>{{ last.PM10 }} мкг/м³</strong></span>
            </div>
            <div class="col-12 py-2">
                <i class="fas fa-fw fa-cloud"></i>
                <span class="pl-3">Вуглекислий газ (CO2): <strong>{{ last.CO2 }} мг/м³ (0.3 ppm)</strong></span>
            </div>
            <div class="col-12 py-2">
                <i class="fas fa-fw fa-thermometer-half"></i>
                <span class="pl-3">Температура: <strong>{{ last.temperature }} °C</strong></span>
            </div>
            <div class="col-12 py-2">
                <i class="fas fa-fw fa-tint"></i>
                <span class="pl-3">Відносна вологість: <strong>{{ last.humidity }} %</strong></span>
            </div>
            <div class="col-12 py-2">
                <i class="fas fa-fw fa-cloud"></i>
                <span class="pl-3">Атмосферний тиск: <strong>{{ (last.pressure / 13.32).toFixed(2) }} мм. рт. ст.</strong></span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "DevData",
    props: ["devStat", "devData"],
    data() {
        return {
            last: {},
            init: false
        }
    },
    watch: {
        devStat(val) {
            if (!this.init) {
                this.last = val?.data?.length ? val.data[0] : {};
                this.init = true;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.box {
    padding: 1.5rem;
    background: #efefef;
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.14);

    .fa-cloud {
        color: #06aef3;
    }

    .fa-tint {
        color: #06aef3;
    }

    .fa-thermometer-half {
        color: #06aef3;
    }
}
</style>